import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
    margin-left: 0.5rem;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
`

const Crumb = styled.div`
    font-size: 0.8rem;
    color: var(--text-color);
    cursor: pointer;
    max-width: 5rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    :hover {
        text-decoration: underline;
    }
`

const Seperator = styled.div`
    margin: 0.3rem;
`

const Breadcrumbs = props => {
    const {
        crumbs,
        separator
    } = props;
    let elements = [];
    crumbs.map((crumb,index) => {

        elements.push(<Crumb key={index} onClick={() => crumb.handler(crumb.value)} last={index === crumbs.length -1}>{crumb.content}</Crumb>);
        if(index !== crumbs.length -1){
            elements.push(<Seperator key='seperator'>{separator || '\\'}</Seperator>)
        }
    })
    return (
        <Container>
            {elements}
        </Container>
    )
}

export default Breadcrumbs;

Breadcrumbs.propTypes = {
    crumbs: PropTypes.array,
    separator: PropTypes.string
}